import React from 'react';

import { Header, Footer } from '../partials';
import { Loader } from '../generic';
import './layouts.css';

class LoaderLayout extends React.Component {
    render(){
        return (
            <div className="layout unauthed-layout loader">
                <Header />
                <div className="main-content">
                    <Loader />
                </div>
                <Footer />
            </div>
        );
    }
}

export default LoaderLayout;


// WEBPACK FOOTER //
// ./src/components/layouts/LoaderLayout.jsx